module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå bistro miljö 2023 1.1745a3e8.jpg";